import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Kit después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un correo con el link de descarga de todos los archivos en formato PDF. El acceso es instantáneo, las 24 horas, los 7 días de la semana.'
}, {
  q: '¿Sirve si mi hijo tiene asma leve o solo episódica?',
  a: 'Sí, y especialmente. Los niños con asma leve o episódica son los que más se benefician de las intervenciones ambientales y nutricionales porque el umbral de crisis es más fácil de bajar con los cambios del entorno.'
}, {
  q: '¿Necesito tecnología especial o equipos caros?',
  a: 'No. Todo el sistema está diseñado para el hogar argentino real. El único equipo recomendado es un higrómetro digital que cuesta entre $2.500 y $4.000 ARS en Mercado Libre. Todo lo demás es aplicación de conocimiento.'
}, {
  q: '¿Los 3 bonos están incluidos en las dos opciones?',
  a: 'Sí. Los 3 bonos (Protocolo de Crisis 2 AM, Manual Escolar y Calendario Estacional 2026) están incluidos en ambas opciones sin costo adicional.'
}, {
  q: '¿Sirve si vivo en el interior del país?',
  a: 'Especialmente. El Bono 3 incluye calendarios regionales específicos para Gran Buenos Aires, Córdoba, Mendoza y Cuyo, Patagonia Norte, NOA y NEA. Cada región tiene su propio mapa de riesgo y protocolo adaptado.'
}, {
  q: '¿Funciona si mi hijo ya tiene tratamiento médico?',
  a: 'Sí, y es exactamente para eso. Este sistema es complementario al tratamiento médico, no lo reemplaza. Está diseñado para reducir la carga alergénica y la inflamación de base para que el tratamiento médico funcione mejor y eventualmente pueda reducirse la dosis.'
}, {
  q: '¿Qué diferencia tiene con los grupos de Facebook o el Dr. Google?',
  a: 'Los grupos de Facebook dan información fragmentada, sin orden, sin contexto clínico y frecuentemente contradictoria. Este sistema es un protocolo estructurado, con secuencia lógica, adaptado al clima y la alimentación argentina, con descargo de responsabilidad médico en cada sección.'
}, {
  q: '¿Por qué elegir el Kit Completo y no solo los tomos?',
  a: 'El Kit Bio-Limpieza Bronquial resuelve el problema que aparece después de que el sistema funciona: la madre que ve mejorar a su hijo pero sigue preocupada por el impacto a largo plazo de la medicación. Es la capa de protección a futuro que cierra el sistema completo.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días completos. Si abrís los tomos, aplicás el primer protocolo y sentís que no era lo que esperabas, te devolvemos el 100% del pago sin ninguna pregunta. La tasa de devolución es menor al 1%.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-14 md:py-20 bg-white" data-id="element-73">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
        <div className="text-center mb-8 sm:mb-10 md:mb-12" data-id="element-75">
          <h2 className="text-sm font-bold text-brand-orange tracking-widest uppercase mb-2" data-id="element-76">
            DUDAS COMUNES
          </h2>
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-gray-900" data-id="element-77">
            PREGUNTAS FRECUENTES
          </h3>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-78">
          {faqs.map((faq, i) => <div key={i} className="border-b border-gray-200 pb-2" data-id="element-79">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full py-3 sm:py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-80">
                <span className="font-bold text-gray-900 pr-8 text-sm sm:text-base" data-id="element-81">
                  {faq.q}
                </span>
                <ChevronDown className={`text-brand-orange flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} size={20} data-id="element-82" />
              </button>
              <AnimatePresence data-id="element-83">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-84">
                    <p className="text-gray-600 pb-4 sm:pb-6 leading-relaxed text-sm sm:text-base" data-id="element-85">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};